export default __webpack_public_path__ + "static/media/arrow-right_up.2e2bbd71.svg";